// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.invite_teams_container_text{
    margin: var(--space-x2);
}

.invite_teams_container_text p{
    margin-bottom: var(--space);
}

.invite_teams_container_text .baloa-subtitle-2 {
    color: var(--primary-very-dark-color);
}

.invite_teams_container_text .baloa-table {
    color: var(--basic-gray-color);
}

.invite_teams_league_add_container_search {
    margin: var(--space);
    width: 55%;
    margin-left: var(--space-x3);
}

.invite_teams_league-addto__container-separator{
    height: 0;
    width: 100%;
    border-bottom: 1px solid var( --new-input-background-color );
    margin: var( --space );
    margin-left: var(--space-x2);
    margin-right: var(--space-x2);
    background-color: var( --new-input-background-color );
}

.invite_teams_league-addto__container__title.baloa-subtitle-2 {
    margin-left: var(--space-x3);
    color: var(--basic-gray-color);
}
.invite_teams_league-add_list {
    overflow: auto;
    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);
}


.invite_teams_league-addto__container ul {
    list-style: none; /* Remove list bullets */
    margin: 0;
    margin-bottom: var(--space-x2);
}

.invite_teams_league-addto__list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: var(--space-half-quarter);
    margin-right: var(--space-half-quarter);
}

.invite_teams_league-addto_list {
    overflow: auto;
    max-height: 300px;
}

.invite_teams_league-addto__list-item_container{
    display: flex;
    align-items: center;
}

.invite_teams_league-addto_list-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-left: var(--space-half-quarter);
    margin-right: var(--space-half-quarter);
}

.invite_teams_league-addto_list-item_img{
    width: var(--space-x2-and-half);
    height: var(--space-x2-and-half);
    float: left;
    margin-top: var(--space);
    margin-bottom: var(--space);
    margin-right: var(--space-half);
    margin-left: var(--space-half);
    border-radius: 50%;
}

.invite_teams_league-addto_list-item .icon-ball {
    color: var( --white-color );
    font-size: var( --space-x2 );
    border-radius: 50%;
    padding: var( --space-quarter );  
}

.invite_teams_league-addto__list-item_text.baloa-names,
.invite_teams_league-addto__list-item_text.baloa-username {
    color: var(--primary-dark-color);
}

.invite_teams_league-addto_list-item_info .invite_teams_league-addto_list-item_text:first-of-type {
    margin-bottom: var( --space-quarter );
}

.invite_teams_league-addto_list-item_container {
    display: flex;
    align-items: center;

}

.invite_teams_league-addto__delete-button .invite_teams_league-addto__delete-button__icon{
    padding: 0px;
    margin-left: auto;
    min-width: var( --space-and-half );
    max-width: var( --space-and-half );
    height: var( --space-and-half );
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var( --new-gray-background-color );
    margin-left: auto;
    color: var( --primary-dark-color );
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-invite-teams/TournamentInviteTeamsComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,SAAS;IACT,WAAW;IACX,4DAA4D;IAC5D,sBAAsB;IACtB,4BAA4B;IAC5B,6BAA6B;IAC7B,qDAAqD;AACzD;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,iEAAiE;AACrE;;;AAGA;IACI,gBAAgB,EAAE,wBAAwB;IAC1C,SAAS;IACT,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sCAAsC;IACtC,uCAAuC;AAC3C;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,WAAW;IACX,wBAAwB;IACxB,2BAA2B;IAC3B,+BAA+B;IAC/B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;IAC3B,4BAA4B;IAC5B,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;;IAEI,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kCAAkC;IAClC,+BAA+B;IAC/B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oDAAoD;IACpD,iBAAiB;IACjB,kCAAkC;AACtC","sourcesContent":[".invite_teams_container_text{\n    margin: var(--space-x2);\n}\n\n.invite_teams_container_text p{\n    margin-bottom: var(--space);\n}\n\n.invite_teams_container_text .baloa-subtitle-2 {\n    color: var(--primary-very-dark-color);\n}\n\n.invite_teams_container_text .baloa-table {\n    color: var(--basic-gray-color);\n}\n\n.invite_teams_league_add_container_search {\n    margin: var(--space);\n    width: 55%;\n    margin-left: var(--space-x3);\n}\n\n.invite_teams_league-addto__container-separator{\n    height: 0;\n    width: 100%;\n    border-bottom: 1px solid var( --new-input-background-color );\n    margin: var( --space );\n    margin-left: var(--space-x2);\n    margin-right: var(--space-x2);\n    background-color: var( --new-input-background-color );\n}\n\n.invite_teams_league-addto__container__title.baloa-subtitle-2 {\n    margin-left: var(--space-x3);\n    color: var(--basic-gray-color);\n}\n.invite_teams_league-add_list {\n    overflow: auto;\n    max-height: calc( calc(var(--space-x3) + var(--space-half)) * 10);\n}\n\n\n.invite_teams_league-addto__container ul {\n    list-style: none; /* Remove list bullets */\n    margin: 0;\n    margin-bottom: var(--space-x2);\n}\n\n.invite_teams_league-addto__list-item {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-left: var(--space-half-quarter);\n    margin-right: var(--space-half-quarter);\n}\n\n.invite_teams_league-addto_list {\n    overflow: auto;\n    max-height: 300px;\n}\n\n.invite_teams_league-addto__list-item_container{\n    display: flex;\n    align-items: center;\n}\n\n.invite_teams_league-addto_list-item{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-left: var(--space-half-quarter);\n    margin-right: var(--space-half-quarter);\n}\n\n.invite_teams_league-addto_list-item_img{\n    width: var(--space-x2-and-half);\n    height: var(--space-x2-and-half);\n    float: left;\n    margin-top: var(--space);\n    margin-bottom: var(--space);\n    margin-right: var(--space-half);\n    margin-left: var(--space-half);\n    border-radius: 50%;\n}\n\n.invite_teams_league-addto_list-item .icon-ball {\n    color: var( --white-color );\n    font-size: var( --space-x2 );\n    border-radius: 50%;\n    padding: var( --space-quarter );  \n}\n\n.invite_teams_league-addto__list-item_text.baloa-names,\n.invite_teams_league-addto__list-item_text.baloa-username {\n    color: var(--primary-dark-color);\n}\n\n.invite_teams_league-addto_list-item_info .invite_teams_league-addto_list-item_text:first-of-type {\n    margin-bottom: var( --space-quarter );\n}\n\n.invite_teams_league-addto_list-item_container {\n    display: flex;\n    align-items: center;\n\n}\n\n.invite_teams_league-addto__delete-button .invite_teams_league-addto__delete-button__icon{\n    padding: 0px;\n    margin-left: auto;\n    min-width: var( --space-and-half );\n    max-width: var( --space-and-half );\n    height: var( --space-and-half );\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: var( --new-gray-background-color );\n    margin-left: auto;\n    color: var( --primary-dark-color );\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
